/*
    work around until we introduce a shared declaration file for project globals.
*/
export const enableAxelArticleWidget = config.enableAxelArticleWidget;
